// extracted by mini-css-extract-plugin
export var baseButton = "_vb-0";
export var controlsArrowKeys = "_vb-1";
export var controlsResetButton = "_vb-2";
export var lightGameButton = "_vb-4 _vb-0";
export var playAgainButton = "_vb-5 _vb-0";
export var startGameButton = "_vb-3 _vb-0";